import React from "react";
import { useTranslation } from "react-i18next";

import {
  IcoClock,
  IcoDone,
  IcoStar,
  IcoWarning,
  Label,
} from "components/generic";
import { TVerify } from "interfaces/intarfaces";

import { theme } from "styles/theme";
import { NotVerification } from "./styles";

export const HostVerify: React.FC<{
  verification_status: TVerify | undefined | "experienced";
  showLabel?: boolean;
  onClick?: () => void;
}> = ({ verification_status = "unverified", showLabel = true, onClick }) => {
  const { t } = useTranslation("hostverify");
  return (
    <NotVerification
      state={verification_status}
      onClick={() => {
        if (onClick) onClick();
      }}
    >
      {showLabel && (
        <Label fontColor="white" bgColor={theme.colors.thirdly}>
          {t(`verifyStatus.${verification_status}.tooltip`)}
        </Label>
      )}
      {(verification_status === "unverified" ||
        verification_status === "failed") && <IcoWarning size="1.4em" />}
      {verification_status === "verifying" && (
        <IcoClock size="1.4em" color={theme.colors.thirdly} />
      )}
      {verification_status === "verified" && (
        <IcoDone size="1.4em" color={theme.colors.text} />
      )}
      {verification_status === "experienced" && (
        <IcoStar size="1.4em" color={theme.colors.text} />
      )}
      {t(`verifyStatus.${verification_status}.title`)}
    </NotVerification>
  );
};
